import { UserApplicationController } from "./controller";
import React from "react";
import { generateUserAccessHistoryTableId } from "./model";
import { AuthZTable } from "../../../../../components/authZTable";
import { formatUtcDateToLocal, parseDate } from "../../../../../common/utils/TimeUtils";
import { sendUserEvent, UserAction } from "../../../../../components/matomoClient";

export const UserApplication = (props) => {
  const { userId, addTabPane } = props;
  const filterKey = "status";
  const actionsKey = "actions";

  const { data, columns, isLoading } = UserApplicationController(userId);

  let modifiedColumns = columns?.map((column) => {
    let { title, render, tableFilter, ...restKeys } = column;

    if (column.key === "lastReviewedAt") {
      render = (dateStr) => {
        if (dateStr === "") return dateStr;
        return formatUtcDateToLocal(parseDate(dateStr), "YYYY-MM-DD HH:mm:ss");
      };
      restKeys = {
        ...restKeys,
        render,
      };
    }

    if (column.key === filterKey) {
      restKeys = {
        ...restKeys,
        filters: tableFilter,
        filterMultiple: false,
        searchEnabled: false,
        sortEnabled: false,
        filterEnabled: true,
      };
    } else if (column.key === actionsKey) {
      render = (text, { actions, appId, application }) => (
        <div
          onClick={() => {
            addTabPane(`${appId}`, `${application} Access history`, appId);
            sendUserEvent(UserAction.UserAccessHistory);
          }}
        >
          <a href="#">
            <span className={"linkSpan"}>{actions}</span>
          </a>
        </div>
      );

      restKeys = {
        ...restKeys,
        searchEnabled: false,
        sortEnabled: false,
        filterEnabled: false,
      };
    }

    if (typeof render == "function") {
      return { ...restKeys, render: render, title: title, width: "25%" };
    } else {
      return { ...restKeys, title: title, width: "25%" };
    }
  });

  return (
    <div>
      <AuthZTable
        id={generateUserAccessHistoryTableId(userId)}
        columns={modifiedColumns}
        dataSource={data}
        loading={isLoading}
        pagination={false}
        scroll={{ y: "calc(64vh)" }}
      />
    </div>
  );
};
